/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { Evidence } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function EvidenceCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    Name: "",
    Description: "",
    ValidFrom: "",
    ValidTo: "",
    Url: "",
  };
  const [Name, setName] = React.useState(initialValues.Name);
  const [Description, setDescription] = React.useState(
    initialValues.Description
  );
  const [ValidFrom, setValidFrom] = React.useState(initialValues.ValidFrom);
  const [ValidTo, setValidTo] = React.useState(initialValues.ValidTo);
  const [Url, setUrl] = React.useState(initialValues.Url);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setName(initialValues.Name);
    setDescription(initialValues.Description);
    setValidFrom(initialValues.ValidFrom);
    setValidTo(initialValues.ValidTo);
    setUrl(initialValues.Url);
    setErrors({});
  };
  const validations = {
    Name: [],
    Description: [],
    ValidFrom: [],
    ValidTo: [],
    Url: [{ type: "URL" }],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          Name,
          Description,
          ValidFrom,
          ValidTo,
          Url,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(new Evidence(modelFields));
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "EvidenceCreateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Evidence Attachment"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Text
        children="Upload evidence to support your record. Enter a description, dates that the evidence is valid for, and select a file."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Divider>
      <TextField
        label="Evidence attachment name"
        isRequired={false}
        isReadOnly={false}
        value={Name}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Name: value,
              Description,
              ValidFrom,
              ValidTo,
              Url,
            };
            const result = onChange(modelFields);
            value = result?.Name ?? value;
          }
          if (errors.Name?.hasError) {
            runValidationTasks("Name", value);
          }
          setName(value);
        }}
        onBlur={() => runValidationTasks("Name", Name)}
        errorMessage={errors.Name?.errorMessage}
        hasError={errors.Name?.hasError}
        {...getOverrideProps(overrides, "Name")}
      ></TextField>
      <TextAreaField
        label="Description"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Name,
              Description: value,
              ValidFrom,
              ValidTo,
              Url,
            };
            const result = onChange(modelFields);
            value = result?.Description ?? value;
          }
          if (errors.Description?.hasError) {
            runValidationTasks("Description", value);
          }
          setDescription(value);
        }}
        onBlur={() => runValidationTasks("Description", Description)}
        errorMessage={errors.Description?.errorMessage}
        hasError={errors.Description?.hasError}
        {...getOverrideProps(overrides, "Description")}
      ></TextAreaField>
      <TextField
        label="Valid from"
        isRequired={false}
        isReadOnly={false}
        type="date"
        value={ValidFrom}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Name,
              Description,
              ValidFrom: value,
              ValidTo,
              Url,
            };
            const result = onChange(modelFields);
            value = result?.ValidFrom ?? value;
          }
          if (errors.ValidFrom?.hasError) {
            runValidationTasks("ValidFrom", value);
          }
          setValidFrom(value);
        }}
        onBlur={() => runValidationTasks("ValidFrom", ValidFrom)}
        errorMessage={errors.ValidFrom?.errorMessage}
        hasError={errors.ValidFrom?.hasError}
        {...getOverrideProps(overrides, "ValidFrom")}
      ></TextField>
      <TextField
        label="Valid to"
        isRequired={false}
        isReadOnly={false}
        type="date"
        value={ValidTo}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Name,
              Description,
              ValidFrom,
              ValidTo: value,
              Url,
            };
            const result = onChange(modelFields);
            value = result?.ValidTo ?? value;
          }
          if (errors.ValidTo?.hasError) {
            runValidationTasks("ValidTo", value);
          }
          setValidTo(value);
        }}
        onBlur={() => runValidationTasks("ValidTo", ValidTo)}
        errorMessage={errors.ValidTo?.errorMessage}
        hasError={errors.ValidTo?.hasError}
        {...getOverrideProps(overrides, "ValidTo")}
      ></TextField>
      <TextField
        label="Url"
        isRequired={false}
        isReadOnly={false}
        value={Url}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Name,
              Description,
              ValidFrom,
              ValidTo,
              Url: value,
            };
            const result = onChange(modelFields);
            value = result?.Url ?? value;
          }
          if (errors.Url?.hasError) {
            runValidationTasks("Url", value);
          }
          setUrl(value);
        }}
        onBlur={() => runValidationTasks("Url", Url)}
        errorMessage={errors.Url?.errorMessage}
        hasError={errors.Url?.hasError}
        {...getOverrideProps(overrides, "Url")}
      ></TextField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
